import { createScenario } from '@funtech-int/rival';
import { lazy } from '@funtech-int/rival-react';

import { RouteSkeleton } from '@/shared/components/PageSpinner/PageSpinner';

import { selectionRoute } from './routes';
import { EmptySelectionError, SelectionNotFoundError } from './lib/error';
import { EmptySelection } from './components/EmptySelection/EmptySelection';
import { SelectionError } from './components/SelectionError/SelectionError';

const scenario = createScenario((ctx) => {
    ctx.addRoute({
        route: selectionRoute,
        meta: {
            plusPaymentPage: 'SelectionScreen',
            page: 'selection',
        },
        component: lazy(() => import('./components/Selection/Selection')),
        fallback: RouteSkeleton,
    });

    ctx.addError({
        is: (error) => error instanceof SelectionNotFoundError,
        component: SelectionError,
    });

    ctx.addError({
        is: (error) => error instanceof EmptySelectionError,
        component: EmptySelection,
    });
});

export * from './routes';

export default scenario;
